import { Component, Injector, Input, OnInit, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AppComponentBase } from 'src/app/shared/app-component-base';
import * as _ from 'lodash';
import { CommonService } from 'src/app-core/services/common.service';

@Component({
  selector: 'app-insurance-cost-breakdown',
  templateUrl: './insurance-cost-breakdown.component.html',
  styleUrls: ['./insurance-cost-breakdown.component.scss']
})
export class InsuranceCostBreakdownComponent extends AppComponentBase implements OnInit {
  @Input() set insuranceCostBreakUpsParam(insuranceCostBreakUps: any) {
    this.insuranceCostBreakUps = insuranceCostBreakUps;
    this.insuranceCostBreakUpsCopy = _.cloneDeep(insuranceCostBreakUps);
    this.calculateTotals();
  }
  insuranceValueTotal: any;
  insuranceCostTotal: any;
  insuranceCostBreakUps: any;
  insuranceCoveragerate: number;
  insuranceCostBreakUpsCopy: any;
  constructor(
    injector: Injector,
    private commonService: CommonService,
    private toastr: ToastrService) {
    super(injector);
  }

  ngOnInit() {
  }

  calculateTotals() {
    if (this.insuranceCostBreakUps) {
      const getTotalcost = this.insuranceCostBreakUps.filter(item => item.insuranceValue).map(x => parseFloat(x.insuranceValue));
      this.insuranceValueTotal = getTotalcost.length ? getTotalcost.reduce((a, b) => (+a) + (+b)).toFixed(2) : 0;
      const getoverallMarkupValue = this.insuranceCostBreakUps.filter(item => item.insuranceCost).map(x => parseFloat(x.insuranceCost));
      this.insuranceCostTotal = getoverallMarkupValue.length ? getoverallMarkupValue.reduce((a, b) => (+a) + (+b)).toFixed(2) : 0;
    }
  }

  calculateInsuranceCost() {
    this.insuranceCoveragerate = this.insuranceCoveragerate ? this.insuranceCoveragerate : 0;
    this.insuranceCostBreakUps.forEach(item => {
      item.insuranceCost = this.commonService.roundNumber((item.insuranceValue * (+this.insuranceCoveragerate)) / 100,   4);
    });
    this.calculateTotals();
  }
}
